module.exports = __webpack_public_path__ + "static/media/magnifying-glass.67440097.svg";